/**
 * @module ol/source/State
 */
/**
 * @enum {string}
 * State of the source, one of 'undefined', 'loading', 'ready' or 'error'.
 */
export default {
    UNDEFINED: 'undefined',
    LOADING: 'loading',
    READY: 'ready',
    ERROR: 'error'
};
//# sourceMappingURL=State.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ol/source/State.js
// module id = 42
// module chunks = 1